var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{
    'text-success': _vm.hasHighlight,
    'font-weight-bold': _vm.hasHighlight
  },style:(("padding-left: " + _vm.moveLeft + "px;"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }